import { capitalizeStr } from '../../../core/utils'

export const applicationDataPreparation = (columns, data, props) => {
  return data.map((item) => {
    const formattedItem = { ...item }
    
    // Format address if needed
    if (formattedItem.direccion) {
      formattedItem.direccion = capitalizeStr(formattedItem.direccion)
    }
    
    // Ensure tableData is preserved if it exists
    if (item.tableData) {
      formattedItem.tableData = { ...item.tableData }
    }
    formattedItem.fecha_creacion_solicitud = props.intl.formatDate(item.fecha_creacion_solicitud)
    
    return formattedItem
  })
}
